import React, { useState } from 'react';

const DriverList = ({ drivers, onRemove, onEdit, isConductor }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredDrivers = drivers.filter(driver =>
    driver.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    driver.license.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <input
        type="text"
        placeholder="Buscar conductor..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        className="mb-4 px-3 py-2 border border-gray-300 rounded-md"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredDrivers.map(driver => (
          <div key={driver.license} className="relative bg-white rounded-xl shadow-md p-6 flex flex-col">
            <div className="flex items-center mb-2">
              <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg">
                {driver.name ? driver.name[0].toUpperCase() : "D"}
              </div>
              <div className="ml-4">
                <div className="font-semibold text-lg">{driver.name}</div>
                <div className="text-gray-500 text-sm">{driver.licenseType} • {driver.license}</div>
              </div>
            </div>
            <div className="flex-1">
              <div className="text-sm text-gray-700 mb-1">
                <span className="font-medium">Teléfono:</span> {driver.phone}
              </div>
              <div className="text-sm text-gray-700 mb-1">
                <span className="font-medium">Email:</span> {driver.email}
              </div>
              <div className="text-sm text-gray-700 mb-1">
                <span className="font-medium">Estado:</span> {driver.status}
              </div>
            </div>
            {!isConductor && (
              <div className="absolute top-2 right-2 flex gap-2">
                <button
                  onClick={() => onEdit(driver)}
                  className="bg-yellow-500 text-white rounded-full p-1 hover:bg-yellow-600 transition-colors"
                  aria-label="Editar conductor"
                >
                  {/* Edit icon (pencil) */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536M9 13h3l8-8a2.828 2.828 0 10-4-4l-8 8v3z" />
                  </svg>
                </button>
                <button
                  onClick={() => onRemove(driver.license)}
                  className="bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors"
                  aria-label="Eliminar conductor"
                >
                  {/* X icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DriverList;